import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore("user", () => {
	// Properties
	const userLoaded = ref()
	const loggedIn = ref()
	const notificationSettings = ref()
	const userFullName = ref()
	const userFirstName = ref()
	const userLastName = ref()
	const userPhone = ref()
	const userPoints = ref()
	const userTotalPoints = ref()
	const referralId = ref()
	const friendsIndex = ref()
	const friends = ref()
	const facebookLoaded = ref(false)
	const facebookUserId = ref("me")
	const userImage = ref()
	const userEmail = ref()
	const userHash = ref()
	const birthday = ref()
	const isInMonthlyTop = ref()
	const monthlyTopUrl = ref()
	const activeSessions = ref()
	const connectionStatus = ref({
		google: null as string|null,
		facebook: null as string|null,
		linkedin: null as string|null,
		apple: null as string|null,
	})
	const connectionStatusDetails = ref({
		google: null as string|null,
		facebook: null as string|null,
		linkedin: null as string|null,
		apple: null as string|null,
	})

	// Actions
	function setUserFirstName(value: string){
		userFirstName.value = value
		userFullName.value = value + " " + userLastName.value
	}

	function setUserLastName(value: string){
		userLastName.value = value
		userFullName.value = userFirstName.value + " " + value
	}

	function setUserPicture(value: string){
		if(friendsIndex.value && friendsIndex.value[facebookUserId.value + ""] && !friendsIndex.value[facebookUserId.value + ""].picture_url){
			friendsIndex.value[facebookUserId.value + ""].picture_url = value
		}

		userImage.value = value
	}

	function setUserTotalPoints(value: number)
	{
		userTotalPoints.value = value

		// Update points in leaderboard
		if(friendsIndex.value && facebookUserId.value && friendsIndex.value[facebookUserId.value + ""]){
			friendsIndex.value[facebookUserId.value + ""].points = value

			// Sort list by points
			friends.value.sort((a: {points:number}, b: {points: number}) => {
				return b.points - a.points
			})
		}
	}

	return {
		userLoaded,
		loggedIn,
		notificationSettings,
		userFullName,
		userFirstName,
		userLastName,
		userPoints,
		userTotalPoints,
		userPhone,
		referralId,
		friendsIndex,
		friends,
		facebookLoaded,
		facebookUserId,
		userImage,
		userEmail,
		userHash,
		birthday,
		isInMonthlyTop,
		monthlyTopUrl,
		connectionStatus,
		connectionStatusDetails,
		activeSessions,
		setUserFirstName,
		setUserLastName,
		setUserPicture,
		setUserTotalPoints,
	}
})